import { Injectable } from '@angular/core';
import { IToast } from '../data/toast';
import { MessageService } from './message.service';

/**
 * Service for handling toast messages
 */
@Injectable({
  providedIn: 'root',
})
export class ToastMessageService extends MessageService<IToast> {
  /**
   * Adds and opens a new toast message.
   *
   * @param message Toast message to show
   */
  public show(message: IToast) {
    const { actions = {} } = message;
    const actionClosed =
      typeof actions.closed === 'function' ? actions.closed : () => {};

    this.add(message);
    this.open(message.key, {
      ...actions,
      closed: (reason) => {
        actionClosed(reason);
        this.remove(message);
      },
    });
  }
}
